// import {OneSignal} from 'react-native-onesignal';
import api from './api';

export async function refreshToken(
  data: {refresh: string; type: 'users'},
  token: string,
): Promise<any> {
  // const oneSignal = await OneSignal.User.pushSubscription.getIdAsync();
  const response = await api.patch(
    '/users/refreshToken',
    {
      ...data,
      // oneSignal
    },
    {
      headers: {
        'x-access-token': token,
      },
    },
  );

  return response;
}

export async function signIn(data: {
  document: string;
  password: string;
}): Promise<any> {
  const response = await api.patch('/users/token', data);

  return response;
}

export async function recoverPassword(data: {document: string}): Promise<any> {
  const response = await api.patch('/users/recoverPassword', data);

  return response;
}

export async function signUp(body: {
  type: 'PF' | 'PJ';
  name: string;
  document: string;
  cep: string;
  address: string;
  email: string;
  password: string;
  city: string;
  neighborhood: string;
  district: string;
  birthDate: string;
  numberAddress?: string;
}): Promise<any> {
  const response = await api.post('/users', body);

  return response;
}

export async function updateUserInfo(
  data: {
    type: 'PF' | 'PJ';
    name: string;
    document: string;
    cep: string;
    address: string;
    email: string;
    password: string;
    city: string;
    neighborhood: string;
    district: string;
    birthDate: string;
    numberAddress?: string;
  },
  idUser: number,
  token: string,
): Promise<any> {
  const response = await api.put(`/users?idUser=${idUser}`, data, {
    headers: {
      'x-access-token': token,
    },
  });

  return response;
}

export async function updatePassword(
  data: {
    password: string;
    newPassword: string;
  },
  idUser: number,
  token: string,
): Promise<any> {
  const response = await api.patch(
    `/users/updatePassword?idUser=${idUser}`,
    data,
    {
      headers: {
        'x-access-token': token,
      },
    },
  );

  return response;
}

export async function deleteUser(idUser: number, token: string): Promise<any> {
  const response = await api.delete(`/users?idUser=${idUser}`, {
    headers: {
      'x-access-token': token,
    },
  });

  return response.data;
}
